export default "__VITE_ASSET__75dc7455__"